 <!--参考 https://github.com/Wanderxx/vue-fullcalendar-->
<template>
  <div class="comp-full-calendar">
    <!-- header pick month -->
    <tc-header :current-date="currentDate" :title-format="titleFormat" :first-day="firstDay" :month-names="localeMonthNames" :short-month-names="localeShortMonthNames" @change="emitChangeMonth">
      <div slot="header-left">
        <slot name="tc-header-left">
        </slot>
      </div>
      <div slot="header-right">
        <slot name="tc-header-right">
        </slot>
      </div>
    </tc-header>
    <!-- body display date day and events -->
    <tc-body :current-date="currentDate" :events="events" :month-names="localeMonthNames" :week-names="localeWeekNames" :first-day="firstDay" @eventclick="emitEventClick" @dayclick="emitDayClick" @moreclick="emitMoreClick">
      <div slot="body-card">
        <slot name="tc-body-card">
        </slot>
      </div>
    </tc-body>
  </div>
</template>
<script>
import Body from './body.vue'
import Header from './header.vue'
import Locale from '../../mixins/locale'
export default {
  components: {
    'tc-body': Body,
    'tc-header': Header
  },
  mixins: [ Locale ],
  props: {
    events: {
      // events will be displayed on calendar
      type: Array,
      default: () => []
    },
    firstDay: {
      type: Number | String,
      validator(val) {
        let res = parseInt(val)
        return res >= 0 && res <= 6
      },
      default: 0
    },
    titleFormat: {
      type: String,
      default() {
        return 'MMMM yyyy'
      }
    },
    monthNames: {
      type: Array,
      default() {
        return []
      }
    },
    weekNames: {
      type: Array,
      default() {
        let arr = []
        return arr.slice(this.firstDay).concat(arr.slice(0, this.firstDay))
      }
    }
  },
  data() {
    return {
      currentDate: new Date()
    }
  },
  computed: {
    localeMonthNames () {
      if (this.monthNames.length === 0) {
        return this.t('t.calendar.months')
      } else {
        return this.monthNames
      }
    },
    localeShortMonthNames () {
      return this.t('t.calendar.shortMonths')
    },
    localeWeekNames () {
      if (this.weekNames.length === 0) {
        return this.t('t.calendar.weeks')
      } else {
        return this.weekNames
      }
    }
  },
  methods: {
    emitChangeMonth(start, end, currentStart, current) {
      this.currentDate = current
      this.$emit('change-month', start, end, currentStart)
    },
    emitEventClick(event, jsEvent, pos) {
      this.$emit('event-click', event, jsEvent, pos)
    },
    emitDayClick(day, jsEvent) {
      this.$emit('day-click', day, jsEvent)
    },
    emitMoreClick(day, events, jsEvent) {
      this.$emit('more-click', day, event, jsEvent)
    }
  }
}
</script>



// WEBPACK FOOTER //
// calendar.vue?c16cdbcc